import React, { ReactElement } from "react"
import * as styles from "./footer.module.scss"

export const Footer = (): ReactElement => (
  <footer className={styles.footer}>
    <p className={styles.campanyName}>運営会社 株式会社アイテック</p>
    <p className={styles.copyright}>COPYRIGHT © ITC. All Rights Reserved.</p>
  </footer>
)
